import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const CredentialsForm = ({ 
  onSubmit, 
  initialData = {}, 
  isLoading = false,
  errors = {}
}) => {
  const [formData, setFormData] = useState({
    clientId: initialData?.clientId || '',
    clientSecret: initialData?.clientSecret || '',
    market: initialData?.market || 'MLA',
    ...initialData
  });

  const [showClientSecret, setShowClientSecret] = useState(false);

  const marketOptions = [
    { value: 'MLA', label: 'Argentina (MLA)', description: 'Peso Argentino (ARS)' },
    { value: 'MLM', label: 'México (MLM)', description: 'Peso Mexicano (MXN)' },
    { value: 'MCO', label: 'Colombia (MCO)', description: 'Peso Colombiano (COP)' },
    { value: 'MLC', label: 'Chile (MLC)', description: 'Peso Chileno (CLP)' },
    { value: 'MLB', label: 'Brasil (MLB)', description: 'Real Brasileño (BRL)' },
    { value: 'MLU', label: 'Uruguay (MLU)', description: 'Peso Uruguayo (UYU)' }
  ];

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSubmit(formData);
  };

  const isFormValid = formData?.clientId?.trim() && formData?.clientSecret?.trim() && formData?.market;

  return (
    <div className="bg-surface border border-border rounded-lg p-6">
      <div className="flex items-center space-x-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Key" size={20} className="text-primary" />
        </div>
        <div>
          <h3 className="font-semibold text-text-primary">Credenciales de API</h3>
          <p className="text-sm text-text-secondary">Configura tu integración con MercadoLibre</p>
        </div>
      </div>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="md:col-span-2">
            <Select
              label="Mercado de MercadoLibre"
              description="Selecciona el país donde publicarás tus productos"
              options={marketOptions}
              value={formData?.market}
              onChange={(value) => handleInputChange('market', value)}
              error={errors?.market}
              required
            />
          </div>

          <div className="md:col-span-2">
            <Input
              label="Client ID"
              type="text"
              placeholder="Ingresa tu Client ID de MercadoLibre"
              description="Obtenlo desde tu panel de desarrollador de MercadoLibre"
              value={formData?.clientId}
              onChange={(e) => handleInputChange('clientId', e?.target?.value)}
              error={errors?.clientId}
              required
            />
          </div>

          <div className="md:col-span-2">
            <div className="relative">
              <Input
                label="Client Secret"
                showPasswordToggle={false}
                type={showClientSecret ? "text" : "password"}
                placeholder="Ingresa tu Client Secret de MercadoLibre"
                description="Mantén este valor seguro y no lo compartas"
                value={formData?.clientSecret}
                onChange={(e) => handleInputChange('clientSecret', e?.target?.value)}
                error={errors?.clientSecret}
                required
              />
              <button
                type="button"
                onClick={() => setShowClientSecret(!showClientSecret)}
                className="absolute right-3 top-8 p-1 text-text-secondary hover:text-text-primary transition-smooth"
              >
                <Icon name={showClientSecret ? "EyeOff" : "Eye"} size={18} />
              </button>
            </div>
          </div>
        </div>

        <div className="bg-muted rounded-lg p-4">
          <div className="flex items-start space-x-3">
            <Icon name="Info" size={20} className="text-primary mt-0.5" />
            <div className="text-sm">
              <p className="font-medium text-text-primary mb-2">¿Cómo obtener tus credenciales?</p>
              <ol className="list-decimal list-inside space-y-1 text-text-secondary">
                <li>Visita el <a href="https://developers.mercadolibre.com" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">Portal de Desarrolladores</a></li>
                <li>Inicia sesión con tu cuenta de MercadoLibre</li>
                <li>Crea una nueva aplicación</li>
                <li>Copia el Client ID y Client Secret generados</li>
              </ol>
            </div>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 pt-4">
          <Button
            type="submit"
            variant="default"
            loading={isLoading}
            disabled={!isFormValid}
            iconName="Save"
            iconPosition="left"
            className="flex-1"
          >
            Guardar Credenciales
          </Button>
          
          <Button
            type="button"
            variant="outline"
            iconName="ExternalLink"
            iconPosition="right"
            onClick={() => window.open('https://developers.mercadolibre.com', '_blank')}
          >
            Portal de Desarrolladores
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CredentialsForm;